import { render, staticRenderFns } from "./bids-quotations.vue?vue&type=template&id=ec4c1818&"
import script from "./bids-quotations.vue?vue&type=script&lang=js&"
export * from "./bids-quotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports